import type { FC } from "react";

import Link from "~/atoms/Link";

const CompanyLogo: FC = () => (
  <Link href="/">
    <span className="sr-only">RocketRent</span>
    <img
      className="hidden w-44 sm:block"
      src="/app/assets/images/rocketrent.png"
      alt="RocketRent Logo"
    />
    <img
      className="h-6 w-auto sm:hidden"
      src="/app/assets/images/rocketrent.png"
      alt="RocketRent Logo"
    />
  </Link>
);

export default CompanyLogo;
